import React from "react";
import classNames from "classnames";
import s from "./MentorCardContainer.pcss";

export default function MentorCardContainer(props) {
    return <div className={classNames(s.container, props.className)}>{props.children}</div>;
}
